import { render, staticRenderFns } from "./LegendItem.vue?vue&type=template&id=0780cf76&"
import script from "./LegendItem.vue?vue&type=script&lang=js&"
export * from "./LegendItem.vue?vue&type=script&lang=js&"
import style0 from "./LegendItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports